function observeAutoplayProgress(emblaApi, getActiveNode, selector) {
  let rafId = 0;
  let activeInner = null;
  let disposed = false;
  const reset = () => {
    cancelAnimationFrame(rafId);
    rafId = 0;
    if (activeInner) {
      activeInner.style.removeProperty("--autoplay-duration");
      activeInner.style.removeProperty("--autoplay-progress");
      activeInner = null;
    }
  };
  const restart = () => {
    var _a;
    reset();
    if (disposed || document.hidden) return;
    const autoplay = (_a = emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    const remaining = autoplay == null ? void 0 : autoplay.timeUntilNext();
    if (!Number.isFinite(remaining) || remaining <= 0) return;
    rafId = requestAnimationFrame(() => {
      var _a2;
      activeInner = (_a2 = getActiveNode()) == null ? void 0 : _a2.querySelector(selector);
      if (!activeInner) {
        rafId = 0;
        return;
      }
      const delay = typeof autoplay.options.delay === "function" ? autoplay.options.delay(emblaApi.scrollSnapList(), emblaApi)[emblaApi.selectedScrollSnap()] : autoplay.options.delay;
      const timeLeft = autoplay.timeUntilNext();
      if (!Number.isFinite(timeLeft) || timeLeft <= 0) {
        reset();
        return;
      }
      const progress = Number.isFinite(delay) && delay > 0 ? Math.max(0, Math.min(1, 1 - timeLeft / delay)) : 0;
      activeInner.style.setProperty("--autoplay-duration", "0ms");
      activeInner.style.setProperty("--autoplay-progress", progress);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        const duration = autoplay.timeUntilNext();
        if (!Number.isFinite(duration) || duration <= 0 || document.hidden) {
          reset();
          return;
        }
        activeInner.style.setProperty("--autoplay-duration", `${duration}ms`);
        activeInner.style.setProperty("--autoplay-progress", 1);
      });
    });
  };
  const onVisibilityChange = () => document.hidden ? reset() : restart();
  const cleanup = () => {
    if (disposed) return;
    disposed = true;
    reset();
    document.removeEventListener("visibilitychange", onVisibilityChange);
    emblaApi.off("autoplay:timerset", restart).off("autoplay:timerstopped", reset).off("autoplay:reset", restart).off("select", restart).off("reInit", restart).off("destroy", cleanup);
  };
  document.addEventListener("visibilitychange", onVisibilityChange);
  emblaApi.on("autoplay:timerset", restart).on("autoplay:timerstopped", reset).on("autoplay:reset", restart).on("select", restart).on("reInit", restart).on("destroy", cleanup);
  restart();
  return cleanup;
}
export {
  observeAutoplayProgress
};
